// Modelo Examen de laboratorio.
export default class LaboratoryExam {
    id=""
    code=""
    exam=""
    group=""        
}



// WEBPACK FOOTER //
// ./src/model/LaboratoryExam.js